import React from 'react';
import { useIntl } from 'react-intl';

import { Actions } from '~/eds/src/components/Actions/Actions';
import { Text } from '~/eds/src/components/Text/Text';
import { StatusType } from '~/eds/src/types/StatusType';
import { Highlight } from '~/features/document-viewer/types/highlight';
import { Uuid } from '~/types/Uuid';

interface Props {
  highlights: Highlight[];
  activeHighlightId?: Uuid;
  onHighlightSourceClick: (highlight: Highlight) => void;
}

export const HighlightSources = ({
  highlights,
  activeHighlightId,
  onHighlightSourceClick,
}: Props) => {
  const intl = useIntl();
  const actions = highlights.map((highlight, index) => ({
    text: `${index + 1}`,
    onClick: () => {
      onHighlightSourceClick(highlight);
    },
    status: (activeHighlightId && highlight.id === activeHighlightId
      ? 'ai'
      : undefined) as StatusType,
  }));

  return (
    <>
      {highlights.length === 0 ? (
        <Text>
          {intl.formatMessage({
            id: 'HighlightSources.noSources',
            defaultMessage: 'There are no sources.',
            description: 'Message shown when there are no highlight sources',
          })}
        </Text>
      ) : (
        <Actions actions={actions} size="s" wrap />
      )}
    </>
  );
};
